export enum SeviceCommandsEnum {
  'run',
  'stop',
  'restart',
}
